import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { getActiveB2BCustomerListInProjectByProjectId } from '@/service/projectService';
import { getWaitingAndRejectB2BCustomerListInProjectFromTicket } from '@/service/ticketService';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import {
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import OverFlowTooltip from '../common/OverFlowTooltip';
import { userAtom } from '@/state/atom/userAtom';
import './BusinessCustomerListInProject.css';
import { isDisableBtnDeleteB2B, onClickDeleteB2BCustomer, filterResultB2BProject } from './handler/BusinessCustomerListInProjectHandler';
import RejectDeleteB2BCustomer from './dialog/RejectDeleteB2BCustomer';
import ConfirmDeleteB2BCustomer from './dialog/ConfirmDeleteB2BCustomer';
import organizationService from '@/service/organizationService';
import { triggerReloadTicketListByPanelType } from '@/state/selector/panelSelector';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';
import tr from '@/common/utils/tr';

export default function BusinessCustomerListInProject(props) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    const { projectId, API, corporationDetail } = props;
    const { affiliationOrganization } = corporationDetail;

    // check is pm
    const isProjectManagerByProject = useRecoilValue(isManagerByProjectInuseSelector);

    const currentUserDetail = useRecoilValue(userAtom);
    const reloadTicketListByPanelType = useSetRecoilState(triggerReloadTicketListByPanelType);

    const [b2bCustomerList, setB2BCustomerList] = useState([]);
    const [isOpenModalRejectDeleteB2B, setIsOpenModalRejectDeleteB2B] = useState(false);
    const [isOpenDialogConfirmDelete, setIsOpenDialogConfirmDelete] = useState(false);
    const [selectedB2BCustomer, setSelectedB2BCustomer] = useState({});

    let argsAll = {
        ...props,
        b2bCustomerList,
        setB2BCustomerList,
        isProjectManagerByProject,
        isOpenModalRejectDeleteB2B,
        setIsOpenModalRejectDeleteB2B,
        isOpenDialogConfirmDelete,
        setIsOpenDialogConfirmDelete,
        selectedB2BCustomer,
        setSelectedB2BCustomer,
        currentUserDetail,
        reloadTicketListByPanelType
    };

    useEffect(() => {
        props.setIsLoading(true);
        (async () => {
            let b2bCustomerActiveList = await getActiveB2BCustomerListInProjectByProjectId(
                API,
                projectId
            );
            let b2bCustomerWaitingAndRejectList = await getWaitingAndRejectB2BCustomerListInProjectFromTicket(
                API,
                affiliationOrganization,
                projectId
            );
            let newB2BCustomerActiveList, newB2BCustomerWaitingAndRejectList;
            [newB2BCustomerActiveList, newB2BCustomerWaitingAndRejectList] = filterResultB2BProject(b2bCustomerActiveList, b2bCustomerWaitingAndRejectList);
            props.setIsLoading(false);
            let result = Utils.sortByUpdatedAtDesc(newB2BCustomerActiveList.concat(newB2BCustomerWaitingAndRejectList))
            result = result?.filter((org) => {
                return org.orgActive !== Constant.CORPORATION_ACTIVE.BLOCK && org.orgActive !== Constant.CORPORATION_ACTIVE.DELETED})
            setB2BCustomerList(result);
        })();
    }, []);

    const renderStatusUser = status => {
        switch (status) {
            case Constant.B2B_CUSTOMER_PROJECT_STATUS.DELETED:
                return (
                    <div
                        className="status-user"
                        style={{ color: '#fff', backgroundColor: '#7f7f7f' }}
                    >
                        {tr('Deleted')}
                    </div>
                );
            case Constant.B2B_CUSTOMER_PROJECT_STATUS.WAITING:
                return (
                    <div
                        className="status-user"
                        style={{ color: '#fff', backgroundColor: '#D09725' }}
                    >
                        {tr('Waiting')}
                    </div>
                );
            case Constant.B2B_CUSTOMER_PROJECT_STATUS.REJECT:
                return (
                    <div
                        className="status-user"
                        style={{ color: '#fff', backgroundColor: '#DF6020' }}
                    >
                        {tr('Reject')}
                    </div>
                );
            case Constant.B2B_CUSTOMER_PROJECT_STATUS.ACTIVE:
                return (
                    <div
                        className="status-user"
                        style={{ color: '#fff', backgroundColor: '#21BA87' }}
                    >
                        {tr('Active')}
                    </div>
                );
            default:
                break;
        }
    };

    const renderLogoCustomer = customer => {
        if (Utils.isEmptyString(customer.logo) || Utils.isEmpty(customer.logo)) {
            if (Utils.isEmpty(customer.orgName) || Utils.isEmptyString(customer.orgName)) {
                return <div className="logo-user"></div>;
            } else {
                return (
                    <div className="logo-user" style={{ width: '48px' }}>
                        {customer.orgName.substring(0, 2)}
                    </div>
                );
            }
        } else {
            return <img src={customer.logo} alt="logo" />;
        }
    };

    const renderTblUserList = () => {
        return (
            <div className="table-tbl table-tbl--account">
                <Table style={{ borderCollapse: 'separate', borderSpacing: 0 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell id="b2b-tbl-first-cell" align="center">
                                {trI18n('USER03LB014')}
                            </TableCell>
                            <TableCell id="b2b-tbl-second-cell" align="left">
                                {trI18n('COMM01LB005')}
                            </TableCell>
                            <TableCell id="b2b-tbl-third-cell" align="left">
                                {trI18n('USER03LB001')}
                            </TableCell>
                            <TableCell id="b2b-tbl-four-cell">
                                <span className="is-disable-column">
                                    {trI18n('FIELDFORMLB022')}
                                </span>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {!Utils.isEmptyArray(b2bCustomerList) &&
                            b2bCustomerList.map(
                                customer =>
                                    !customer.isDisable && (
                                        <TableRow key={customer?.id}>
                                            {/* logo  */}
                                            <TableCell className="cell-group-b2b">
                                                <div className="b2b-tbl-logo">
                                                    {renderLogoCustomer(customer)}
                                                </div>
                                            </TableCell>
                                            {/* name org  */}
                                            <TableCell className="cell-group-b2b" id="b2b-nameOrg">
                                                <OverFlowTooltip value={customer.orgName} />
                                                <div>
                                                    {tr(
                                                        Utils.formatStringUpperCaseFirstLetter(
                                                            organizationService.convertContractTypeToJPName(
                                                                customer.contractType ===  Constant.CORPORATION_CONTRACT_TYPE
                                                                .PREMIUM
                                                                ? Constant.CORPORATION_CONTRACT_TYPE
                                                                    .STANDARD
                                                                : customer.contractType
                                                            )
                                                        )
                                                    )}
                                                </div>
                                            </TableCell>
                                            {/* name project  */}
                                            <TableCell className="cell-group-b2b" id="b2b-namePJ">
                                                <OverFlowTooltip value={customer.projectName} />
                                            </TableCell>
                                            {/* status and btn action  */}
                                            <TableCell className="cell-group-info">
                                                <div className="action-group action-group-b2b">
                                                    <div className="group-status">
                                                        {renderStatusUser(customer.status)}
                                                    </div>
                                                    <div>
                                                        <div className="groupBtn-action">
                                                            <Button
                                                                className="btn-action"
                                                                disabled={isDisableBtnDeleteB2B(
                                                                    argsAll,
                                                                    customer
                                                                )}
                                                                onClick={() =>
                                                                    onClickDeleteB2BCustomer(
                                                                        argsAll,
                                                                        customer
                                                                    )
                                                                }
                                                            >
                                                                <img
                                                                    src="/assets/image/delete-icon.svg"
                                                                    alt=""
                                                                    disabled
                                                                />
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    )
                            )}
                    </TableBody>
                </Table>
            </div>
        );
    };

    return (
        <div className="projectUser-table" data-cy="project-users-table-list">
            {renderTblUserList()}
            {isOpenModalRejectDeleteB2B && (
                <RejectDeleteB2BCustomer argsAll={argsAll} isOpen={isOpenModalRejectDeleteB2B} setIsOpen={setIsOpenModalRejectDeleteB2B} />
            )}
            {isOpenDialogConfirmDelete && (
                <ConfirmDeleteB2BCustomer {...argsAll} isOpen={isOpenDialogConfirmDelete} setIsOpen={setIsOpenDialogConfirmDelete} />
            )}
        </div>
    );
}
